export default "/images/framework/face_1.319e0031.png?319e0031";